export default __webpack_public_path__ + "static/media/mszp.137e543f.png";